import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const ConspiracyTheory = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.conspiracyTheory.title')}
      contentType="conspiracyTheory"
      description={t('page.conspiracyTheory.desc')}
      outputLabel={t('page.conspiracyTheory.output')}
    />
  );
};
